const { Modal, Box } = require("@mui/material");
import PropTypes from "prop-types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const MDModal = ({ children, isOpen, handleModal }) => (
  <Modal
    open={isOpen}
    onClose={handleModal}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    {/* <Box sx={{ ...style, width: 400 }}>{children}</Box> */}
    <Box sx={{ ...style, width: 400 }}>{children}</Box>
  </Modal>
);

MDModal.propTypes = {
  children: PropTypes.object,
  isOpen: PropTypes.bool,
  handleModal: PropTypes.func,
};

export default MDModal;
